import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Bind } from 'lodash-decorators';
import DebugOptionWrapper from './DebugOptionWrapper';
import DebugOptionLabel from './DebugOptionLabel';
import DebugOptionInput from './DebugOptionInput';
import DebugOptionGroupLabel from './DebugOptionGroupLabel';

class DebugOption extends Component {
  @Bind
  handleOptionChange(event) {
    const { optionName, onValueChange } = this.props;
    onValueChange({ name: optionName, value: event.target.value });
  }

  render() {
    const { optionName, values, checked } = this.props;
    return (
      <DebugOptionWrapper>
        <DebugOptionGroupLabel>
          {`${optionName}:`}
        </DebugOptionGroupLabel>
        {values.map(value => (
          <DebugOptionLabel key={value}>
            {value}
            <DebugOptionInput
              type="radio"
              checked={value === checked}
              onChange={this.handleOptionChange}
              value={value}
              name={optionName}
            />
          </DebugOptionLabel>
        ))}
      </DebugOptionWrapper>
    );
  }
}
DebugOption.propTypes = {
  optionName: PropTypes.string.isRequired,
  values: PropTypes.arrayOf(PropTypes.string).isRequired,
  onValueChange: PropTypes.func.isRequired,
  checked: PropTypes.string,
};
DebugOption.defaultProps = {
  checked: '',
};

export default DebugOption;



// WEBPACK FOOTER //
// ./src/blocks/DebugComponents/DebugBar/DebugOption/index.jsx